import React from 'react';
import Content from './Content';
import { translate } from '../../../../Services/translation';
import { ACCORDION_PANEL_MEASUREMENTS } from "../../../Constants"

const AccordionTab = ({ id, type, isOpen, title, data, onClick, onKeyDown }) => {
    const handleClick = () => onClick && onClick(id);
    const handleKeyDown = (e) => {
        if (onKeyDown) {
            onKeyDown(e, id);
        }
    };


    const icon = isOpen ? '-' : '+';

    const renderData = () =>
        data.map((props, k) => <Content key={k} {...props} type={type} />);

    return (
        <div className="accordion-tab">
            <p
                className={`accordion-tab__title ${isOpen ? 'open' : ''}`}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                tabIndex={0}
            >
                {title}
                <span className="accordion-tab__title__icon">{icon}</span>
            </p>
            {isOpen && (
                <div className="accordion-tab__panel">
                    {type === ACCORDION_PANEL_MEASUREMENTS ? (
                        <ul>{renderData()}</ul>
                    ) : (
                        data.filter(x => x.articleNumber !== null).length > 0 ? <>
                            <div className="accordion-tab__panel__text">
                                <div className="accordion-tab__panel__headertext">
                                    <span className="accordion-tab__panel__headertext__first">{translate('product.information.paket.articleNumber')}</span>
                                    <span className="accordion-tab__panel__headertext__last">{translate('product.information.paket.name')}</span>
                                    <span className="accordion-tab__panel__headertext__quantity">{translate('product.information.paket.quantity')}</span>
                                </div>
                            </div>
                            {renderData()}
                        </> :
                            <>{renderData()}</>
                    )}
                </div>
            )}
        </div>
    );
};

export default AccordionTab;
